// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"714":"c6cbc68d","811":"222ce82e"}[chunkId] + ".chunk.js";
};